<template>
    <div class="tw-flex tw-flex-col tw-gap-2">
        <q-skeleton type="rect" width="100%" height="50px" class="tw-rounded-[3px]" animation="pulse-y" />
        <q-skeleton type="rect" width="100%" height="50px" class="tw-rounded-[3px]" animation="pulse-y" />
        <q-skeleton type="rect" width="100%" height="50px" class="tw-rounded-[3px]" animation="pulse-y" />
        <q-skeleton type="rect" width="100%" height="50px" class="tw-rounded-[3px]" animation="pulse-y" />
    </div>
</template>

<script setup lang="ts"></script>
